(function($) {
  /**
	 * AJAX Popup
	 * @since 2019-04-22
	 */
	$(document).on('click', '.js-ajax-popup', event => {
		event.preventDefault();

		var source = event.currentTarget.href;
		$.magnificPopup.open({
			type: 'ajax',
			items: {
				src: source
			},
			mainClass: 'component-popup mfp-slide-up',
			removalDelay: 200
		})
	});

	/**
	 * Inlnie Popup
	 * @since 2019-04-25
	 */
	$(document).on('click', '.js-inline-popup', event => {
		event.preventDefault();

		var source = event.currentTarget.hash;
		$.magnificPopup.open({
			type: 'inline',
			items: {
				src: source
			},
			mainClass: 'component-popup mfp-slide-up',
			removalDelay: 200
		});
	});
        
	$(document).on('click', '.js-inline-popup-custom', event => {
            event.preventDefault();

            var source = event.currentTarget.hash;
            var keepState = event.currentTarget.classList.contains('is-keep-state');
            
            if (!keepState) {
                window.ClearAllData();
            }
            
            $.magnificPopup.open({
                type: 'inline',
                items: {
                        src: source
                },
                mainClass: 'component-popup mfp-slide-up',
                removalDelay: 200,
                closeOnBgClick: false
            });
	});
})(jQuery);